<template>
  <v-col sm="6" md="4" lg="2">
    <v-select
      item-text="name"
      item-value="name"
      :items="enumItems"
      :label="label"
      v-model="itemValue"
      name="item"
      @input="handleInput"
    >
      <v-icon slot="append" title="removeFilter" @click="$emit('remove')">
        mdi-close
      </v-icon>
    </v-select>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ChannelFilter",
  props: {
    channels: [],
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    value: {},
    allowEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      availableItems: this.channels,
      itemValue: this.value,
      closeOnContentClick: true,
    };
  },
  watch: {
    value: {
      handler: function () {
        this.itemValue = this.value;
      },
      deep: true,
    },
  },
  methods: {
    handleInput: function () {
      this.$emit("input", this.itemValue);
    },
  },
  computed: {
    ...mapGetters("channels", ["channelList"]),
    enumItems: function () {
      let channels = this.channelList;
      if (this.allowEmpty) {
        channels.unshift({
          key: "notSet",
          item: "notSet",
        });
      }
      return channels;
    },
  },
};
</script>
